(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-conversion-pro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-section-type="pdp-conversion-pro"]');
    if (!root) return;

    const endRaw = root.dataset.pdpcpCountdownEnd;
    if (endRaw) {
      const end = Date.parse(endRaw);
      const els = {
        d: root.querySelector('[data-pdpcp-timer-days]'),
        h: root.querySelector('[data-pdpcp-timer-hours]'),
        m: root.querySelector('[data-pdpcp-timer-mins]'),
        s: root.querySelector('[data-pdpcp-timer-secs]'),
      };
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        if (!els.d) return;
        const now = Date.now();
        let ms = end - now;
        if (ms <= 0) {
          els.d.textContent = els.h.textContent = els.m.textContent = els.s.textContent = '00';
          return;
        }
        const sec = Math.floor(ms / 1000);
        const days = Math.floor(sec / 86400);
        let rem = sec % 86400;
        const hours = Math.floor(rem / 3600);
        rem %= 3600;
        const mins = Math.floor(rem / 60);
        const secs = rem % 60;
        els.d.textContent = pad(days);
        els.h.textContent = pad(hours);
        els.m.textContent = pad(mins);
        els.s.textContent = pad(secs);
      };
      tick();
      setInterval(tick, 1000);
    }

    const gallery = root.querySelector('[data-pdpcp-gallery]');
    if (gallery) {
      const main = gallery.querySelector('[data-pdpcp-main]');
      const thumbs = gallery.querySelectorAll('[data-pdpcp-thumb]');
      const prev = gallery.querySelector('[data-pdpcp-prev]');
      const next = gallery.querySelector('[data-pdpcp-next]');
      const raw = root.querySelector('[data-pdpcp-media-json]');
      let media = [];
      try {
        media = raw ? JSON.parse(raw.textContent) : [];
      } catch (e) {
        media = [];
      }
      let idx = 0;
      const setActiveThumb = (i) => {
        thumbs.forEach((t) => t.classList.toggle('is-active', Number(t.dataset.pdpcpThumb) === i));
      };
      const renderMain = (i) => {
        const item = media[i];
        if (!item || !main) return;
        idx = i;
        setActiveThumb(i);
        const img = document.createElement('img');
        img.className = 'pdpcp-gallery__media';
        img.src = item.image_src;
        img.alt = typeof item.alt === 'string' ? item.alt : '';
        img.width = 1400;
        img.height = 1400;
        img.loading = 'lazy';
        main.replaceChildren(img);
      };
      thumbs.forEach((t) => {
        t.addEventListener('click', () => renderMain(Number(t.dataset.pdpcpThumb)));
      });
      if (prev && next && media.length) {
        prev.addEventListener('click', () => {
          renderMain((idx - 1 + media.length) % media.length);
        });
        next.addEventListener('click', () => {
          renderMain((idx + 1) % media.length);
        });
      }
    }

    const variantSelect = root.querySelector('[data-pdpcp-variant-select]');
    const variantsRaw = root.querySelector('[data-pdpcp-variants]');
    let variants = [];
    try {
      variants = variantsRaw ? JSON.parse(variantsRaw.textContent) : [];
    } catch (e) {
      variants = [];
    }
    const priceEl = root.querySelector('[data-pdpcp-price]');
    const compareEl = root.querySelector('[data-pdpcp-compare]');
    const saveEl = root.querySelector('[data-pdpcp-buy-box] .pdpcp-buy__save');
    const submit = root.querySelector('[data-pdpcp-submit]');
    const stickyPrice = root.querySelector('[data-pdpcp-sticky-price]');

    const syncVariant = (id) => {
      const v = variants.find((x) => String(x.id) === String(id));
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price_formatted;
      if (stickyPrice) stickyPrice.textContent = v.price_formatted;
      if (compareEl) {
        if (v.compare_formatted) {
          compareEl.style.display = '';
          compareEl.textContent = v.compare_formatted;
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (saveEl) saveEl.style.display = v.compare_formatted ? '' : 'none';
      if (submit) {
        submit.disabled = !v.available;
        const atc = submit.dataset.labelAtc || '';
        const so = submit.dataset.labelSoldout || '';
        submit.textContent = v.available ? atc : so;
      }
    };
    if (variantSelect) {
      variantSelect.addEventListener('change', () => syncVariant(variantSelect.value));
    }

    const sticky = root.querySelector('[data-pdpcp-sticky]');
    const buyBox = root.querySelector('[data-pdpcp-buy-box]');
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          const e = entries[0];
          const show = !e.isIntersecting;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        },
        { threshold: 0.1 }
      );
      io.observe(buyBox);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
